import React from "react";
import { Link } from "react-router-dom";

const PrivacyPolicy: React.FC = () => {
  return (
    <section
      style={{
        padding: "40px 6%",
        maxWidth: "800px",
        margin: "0 auto",
        lineHeight: "1.6",
      }}
    >
      <Link
        to="/"
        style={{
          color: "#017E84",
          textDecoration: "none",
          fontWeight: "bold",
          display: "inline-block",
          marginBottom: "20px",
        }}
      >
        ← Back to Home
      </Link>
      <h1 style={{ color: "#714B67" }}>Privacy Policy</h1>
      <p>Last Updated: January 2026</p>

      <p>
        At <strong>SOCIALFLOW</strong>, we value your privacy. This policy
        explains how we handle your information.
      </p>

      <h3>1. Information We Collect</h3>
      <p>
        When you sign in using Google, we collect your{" "}
        <strong>email address, name, and profile picture</strong>. This allows
        us to create your account and provide access to features like
        "Projects."
      </p>

      <h3>2. How We Use Your Data</h3>
      <p>Your data is used strictly for:</p>
      <ul>
        <li>Account management and authentication.</li>
        <li>Saving your personal projects (tags, titles, and ideas).</li>
        <li>Providing customer support.</li>
      </ul>

      <h3>3. Data Protection</h3>
      <p>
        <strong>
          We do not sell, rent, or trade your personal information to third
          parties.
        </strong>{" "}
        Your data is stored securely using industry-standard cloud encryption.
      </p>

      <h3>4. Your Rights</h3>
      <p>
        You can request to delete your account and all associated data at any
        time by contacting us at avalancheindia999@gmail.com.
      </p>
    </section>
  );
};

export default PrivacyPolicy;
